import { render, staticRenderFns } from "./Cxgaxx.vue?vue&type=template&id=d32791ce&scoped=true&"
import script from "./Cxgaxx.vue?vue&type=script&lang=js&"
export * from "./Cxgaxx.vue?vue&type=script&lang=js&"
import style0 from "./Cxgaxx.vue?vue&type=style&index=0&id=d32791ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32791ce",
  null
  
)

export default component.exports